<template>
    <div>
        <v-list-item :value="item" style="min-height: 60px;">
            <template>
                <v-list-item-content>
                    <div v-if="layer === 1" style="position:relative;display:grid;grid-template-columns: auto auto auto auto auto auto auto auto auto;grid-template-rows: auto;">
                        <td><span style="text-align: center;">{{ item.children.length }}</span></td>
                        <td><span>{{ item.dateRange }}</span></td>
                        <td><span>{{ $dayjsLocalToUTC(item.slotTime, 'vt') }}</span></td>
                        <td>
                            <div>{{ item.aircraftType.code }}</div>
                            <a>{{ item.changedAircraft.code }}</a>
                        </td>
                        <div
                            style="display: grid;grid-template-rows: auto auto;text-align: center;"
                            :style="{gridTemplateColumns: item.flightNo[1] ? 'auto auto auto' : 'auto' }">
                            <div>
                                {{ item.flightNo[0] }}</div>
                            <div v-if="item.flightNo[1]">
                                /
                            </div>
                            <div v-if="item.flightNo[1]">
                                {{ item.flightNo[1] }}
                            </div>
                            <a>
                                {{ item.changedFlightNo[0] }}
                            </a>
                            <div v-if="item.changedFlightNo[1]">
                                /
                            </div>
                            <a>
                                {{ item.changedFlightNo[1] }}
                            </a>
                        </div>
                        <td>
                            <div class="font-weight-bold">
                                {{ item.airportSlot.aptCode }}
                            </div>
                        </td>
                        <td>
                            <div style="display: grid;grid-template-rows: auto auto;grid-template-columns: auto auto">
                                <div>{{ item.slot[0] }}</div>
                                <div>{{ item.slot[1] }}</div>
                                <a>{{ item.changedSlot[0] }}</a>
                                <a>{{ item.changedSlot[1] }}</a>
                            </div>
                        </td>
                        <td>
                            <v-tooltip
                                v-for="(warning, index) in item.warnings"
                                :key="index"
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        color="red"
                                        :style="{marginLeft: index !== 0 ? '14px' : ''}"
                                        v-bind="attrs"
                                        v-on="on">
                                        {{ warning.icon }}
                                    </v-icon>
                                </template>
                                <span>{{ warning.text }}</span>
                            </v-tooltip>
                        </td>
                        <td>
                            <v-chip>{{ item.status }}</v-chip>
                        </td>
                    </div>
                    <div v-else-if="layer === 2" style="position:relative;display:grid;grid-template-columns: auto auto auto auto auto auto auto auto;grid-template-rows: auto;">
                        <td>
                            <span>{{ $dayjsLocalToUTC(item.slotTime, 'DD.MM.YYYY') }}</span>
                        </td>
                        <td><span>{{ $dayjsLocalToUTC(item.slotTime, 'vt') }}</span></td>
                        <td>
                            <div>{{ item.aircraftType.code }}</div>
                            <a>{{ item.changedAircraft.code }}</a>
                        </td>
                        <td>
                            <div style="display: grid;grid-template-rows: auto auto;" :style="{gridTemplateColumns: item.flightNo[1] ? 'auto auto auto' : 'auto' }">
                                <div>
                                    {{ item.flightNo[0] }}</div>
                                <div v-if="item.flightNo[1]">
                                    /
                                </div>
                                <div v-if="item.flightNo[1]">
                                    {{ item.flightNo[1] }}
                                </div>
                                <a>
                                    {{ item.changedFlightNo[0] }}
                                </a>
                                <div v-if="item.changedFlightNo[1]">
                                    /
                                </div>
                                <a>
                                    {{ item.changedFlightNo[1] }}
                                </a>
                            </div>
                        </td>
                        <td>
                            <div class="font-weight-bold">
                                {{ item.airportSlot.aptCode }}
                            </div>
                        </td>
                        <td>
                            <div style="display: grid;grid-template-rows: auto auto;grid-template-columns: auto auto">
                                <div>{{ item.slot[0] }}</div>
                                <div>{{ item.slot[1] }}</div>
                                <a>{{ item.changedSlot[0] }}</a>
                                <a>{{ item.changedSlot[1] }}</a>
                            </div>
                        </td>
                        <td>
                            <v-tooltip
                                v-for="(warning, index) in item.warnings"
                                :key="index"
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        color="red"
                                        :style="{marginLeft: index !== 0 ? '14px' : ''}"
                                        v-bind="attrs"
                                        v-on="on">
                                        {{ warning.icon }}
                                    </v-icon>
                                </template>
                                <span>{{ warning.text }}</span>
                            </v-tooltip>
                        </td>
                        <td>
                            <v-chip>{{ item.status }}</v-chip>
                        </td>
                    </div>
                    <div v-else-if="layer === 3" style="position:relative;display:grid;grid-template-columns: auto auto auto auto auto auto auto auto;grid-template-rows: auto;">
                        <td>
                            <span>{{ $dayjsLocalToUTC(item.slotTime, 'DD.MM.YYYY') }}</span>
                        </td>
                        <td><span>{{ $dayjsLocalToUTC(item.slotTime, 'vt') }}</span></td>
                        <td>
                            <div>{{ item.aircraftType.code }}</div>
                            <a>{{ item.changedAircraft.code }}</a>
                        </td>
                        <td>
                            <div style="display: grid;grid-template-rows: auto auto;" :style="{gridTemplateColumns: 'auto' }">
                                <div>
                                    {{ item.flightNo }}
                                </div>
                                 <a>
                                    {{ item.changedFlightNo[0] }}
                                </a>
                            </div>
                        </td>
                        <td>
                            <div class="font-weight-bold">
                                {{ item.airportSlot.aptCode }}
                            </div>
                        </td>
                        <td>
                            <div style="display: grid;grid-template-rows: auto auto;grid-template-columns: auto">
                                <div>{{ item.slot }}</div>
                                <a>{{ item.changedSlot[0] }}</a>
                            </div>
                        </td>
                        <td>
                            <v-tooltip
                                v-for="(warning, index) in item.warnings"
                                :key="index"
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        color="red"
                                        :style="{marginLeft: index !== 0 ? '14px' : ''}"
                                        v-bind="attrs"
                                        v-on="on">
                                        {{ warning.icon }}
                                    </v-icon>
                                </template>
                                <span>{{ warning.text }}</span>
                            </v-tooltip>
                        </td>
                        <td>
                            <v-chip>{{ item.status }}</v-chip>
                        </td>
                    </div>
                </v-list-item-content>
            </template>
        </v-list-item>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { mapGetters } from 'vuex';


    export default {
        name: 'Selectedflightslistitem', // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components: {},

        /* >>> *************************************************************** / /* Props */
        props: {

            item: Object,
            layer: Number

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data() {

            return {};

        }, // eo data{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([])

        }, // eo computed
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        created: function () {

            const me = this;


            me.$toc('>>> views/flights/flights/components/crud/SelectedFlightListItem.vue >>> created');

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::destroyed
        *
        * Desc:
        * Note:
        *
        */
        destroyed: function () {

            const me = this;


            me.$toc('>>> views/flights/flights/components/crud/SelectedFlightListItem.vue >>> destroyed');

        }, // eo function destroyed()



        /* >>> *************************************************************** / /* Methods */
        methods: {

            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /******************************************************************* ''
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * get_ClassForEditedRow()
            *
            * Desc: Returns selected Class if Row was edited (prop: 'wasEdited')
            * Note:
            *
            */
			get_ClassForEditedRow: function(item) {

                const me = this;


                me.$toc('>>> views/flights/flights/components/crud/SelectedFlightListItem.vue >>> get_ClassForEditedRow');
				return item.wasEdited === true ? 'rowWasEdited' : '';

            }, // eo function get_ClassForEditedRow()

            /*******************************************************************
			* helper_getSlotInfo()
			*
			* Desc: Checks if Slot is needed and mismatching slot
            * Note:
            *
			*/
			helper_getSlotInfo: function (apt, scheduled, slot) {

				let color = 'black',
					time = '';

				if (apt.coordinated) {
					if (Vue.prototype.$isMismatchingSlot(scheduled, slot)) {
						color = 'red';
					}
					if (!slot) {
						time = 'XXXX';
					} else {
						time = Vue.prototype.$dayjsLocalToUTC(slot, 'HHmm');
					}

					return `<span style="color:${color}">${time}</span>`;
				} else {

					return '';
				}
            } // eo function helper_getSlotInfo()

        } // eo methods{}
        /* <<< ****************************************************************/
    };
</script>

<style scoped>
    .v-card .v-divider {
        border-color: #d2d2d2;
    }

    .v-list-item {
        padding: 0 26px;
    }
    .rowWasEdited {
        /* border-left: 4px solid #AB3B7C;
        padding-left: 4px; */
        /* background-color: #AB3B7C; */
        border: 2px solid #AB3B7C;
        padding: 2px;
	}
</style>
